import { useTrans } from 'hooks'
import Icon from './Icon'

function Salva({ saved, onClick = () => {}, horizontal = false }) {
  const t = useTrans()
  return (
    <button
      type="button"
      className={`salva ${horizontal ? 'salva--horizontal' : ''}`}
      aria-label={t(saved ? 'Rimuovi dalla tua libreria' : 'Aggiungi alla tua libreria')}
      onClick={onClick}
    >
      <Icon
        id={saved ? 'heart-full' : 'heart'}
        classes="icon--heart"
        tooltip={saved ? 'Rimuovi dalla tua libreria' : 'Aggiungi alla tua libreria'}
      />
    </button>
  )
}

export default Salva
